import $ from "jquery";
import "jquery.easing";
import app, { vuwer, csl } from "@@assets/scripts/common";

vuwer.get("pageHeader").setProp({
	onReady($self) {
		const $slider = $("#imgSlider");
		csl.log.orange("**", { $slider });
		
		$slider.children().each((i, elm) => {
			// imgのsrcをelmのdata-srcに記述後、imgをremove
			const $elm = $(elm);
			const $img = $elm.children().eq(0).remove();
			$elm.attr("data-src", $img.attr("src"));
		});
		
		// camera.js内に$.liveの記述があるのでその対応
		$.fn.live = function() {
			this.on(arguments);
		};
		
		let height = "420px";
		if(app.device[0] === "sp") {
			height = "210px";
		}
		
		$slider.camera({
			autoAdvance: true,
			mobileAutoAdvance: true,
			loader: "none",
			navigation: false,
			navigationHover: false,
			pagination: false,
			playPause: false,
			hover: false,
			mobileNavHover: false,
			pauseOnClick: false,
			fx: "mosaic, mosaicReverse",
			height
		});
	}
});
